jQuery(function($) {

  // Team Member Slider
  var $teamSlider = $('.team-slider');  
      
  $($teamSlider).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    appendArrows: $('.reveal .arrows'),
    infinite: false,
  });

  $('.employee').click(function() {
    var $teamIndex = $(this).data('team-index') - 1;
    $($teamSlider).slick('slickGoTo', $teamIndex);
  });

  $('[data-reveal]').on('open.zf.reveal', function() {
    $teamSlider.resize();
  }); 
          
    $(".tabs").on("change.zf.tabs", function () {
      $(".slick-slider").slick("setPosition");
  });         
});